// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1zNao","title":"Info_title__2n2kC","selects":"Info_selects__1EgwJ","requiredAsterisk":"Info_requiredAsterisk__34J66"};